<div class="m-mat-snackbar">
	<div *ngIf="data.isHtml != true" class="m-mat-snackbar__message">{{data.message}}</div>
	<span *ngIf="data.isHtml == true" [innerHtml]="data.message | replaceLineBreaks"></span>
	<div class="m-mat-snackbar__btn">
		<button *ngIf="data.showUndoButton" type="button" mat-button color="primary" (click)="onDismissWithAction()">
			Undo
		</button>
	</div>
	<div class="m-mat-snackbar__close">
		<button *ngIf="data.showCloseButton" 
			mat-icon-button 
			(click)="onDismiss()"
			color="warn">
			<mat-icon>clear</mat-icon>
		</button>
	</div>
</div>
